// Примечание переводчику: Сохраняйте деловой нейтральный стиль, женский род для артиста, не переводите отраслевые термины
// (GoGo, Crazy menu и т.п.), а также плейсхолдеры вида {count} и текст в кавычках — от них зависят интерфейс и форматирование.
export const popups = {
  registerRequest: {
    title: 'Заявка на регистрацию',
    description: 'Заполните анкету и мы свяжемся с вами.',
    button: 'Оставить заявку для регистрации',
    form: {
      noteLabel: 'Как вы о нас узнали?',
      notePlaceholder: 'Как вы о нас узнали?',
      checkboxExperience: 'Я с опытом работы в клубе',
      club: {
        nameLabel: 'Название клуба',
        namePlaceholder: 'Название клуба'
      }
    }
  },
  invite: {
    title: 'Подтвердите возраст',
    description:
      'Подтвердите, что вам исполнилось 18 лет для использования платформы',
    confirm: 'Да, мне есть 18'
  },
  deleteAccount: {
    title: 'Удалить аккаунт?',
    subTitle: 'Отменить удаление будет невозможно.',
    description:
      'Вместо удаления, профиль можно скрыть. Он не будет доступен никому кроме вас, до тех пор пока ві не решите откріть его.'
  },
  exitFromProfile: {
    title: 'Хотите выйти?',
    description: 'Подтвердите выход из аккаунта'
  },
  hideAccount: {
    title: 'Скрыть аккаунт?',
    description:
      'Ваш профиль будет недоступен для просмотра никому, кроме вас до тех пор,пока вы не решите открыть его. Это скроет ваш аккаунт от клубов и других артисток.'
  },
  mainPhoto: {
    title: 'Главное фото',
    description: 'Укажите фото обложки для поиска'
  },
  updateVideo: {
    title: 'Загрузка Видео',
    description: 'Дождитесь загрузки видео'
  },
  consumation: {
    title: 'Консумация',
    description:
      'Введите 5 самых популярных позиций из консумации, сколько стоит каждая позиция и процент от цены для выплат артистке.'
  },
  crazyMenu: {
    title: 'Крейзи меню',
    description:
      'Введите 5 самых популярных позиций из крейзи меню и стоимость каждой.'
  },
  warningOnCloseOnboarding: {
    title: 'Вы уверены ?',
    description:
      'Вы действительно хотите прервать заполнение резюме? Ваше объявление не будет опубликовано. Клубы не смогут высылать вам приглашения.'
  },
  foreignLanguage: {
    title: 'Уровень владения'
  },
  createWorkItem: {
    title: 'Подтверждение',
    titleRequest: 'Подтверждение',
    inviteDescription:
      'Эта информация предположительная. Вы можете обговорить ее в чате с артисткой и обновить приглашение',
    requestDescription:
      'Эта информация предположительная. Вы можете обговорить ее в чате с клубом и обновить заявку',
    suggestVacancy: 'Предложите вакансию для артистки',
    selectVacancy: 'Укажите интересующую вакансию',
    ticketCreditOption: 'Возможность кредитования билета',
    ticketCreditRequired: 'Нужно ли кредитование билета?'
  },
  clubWorkInteraction: {
    artistWorkAtClub: 'Артист работает в вашем клубе.',
    setLastDay: {
      title: 'Установить последнюю дату',
      setLastWorkDate: 'Укажите дату последнего рабочего дня артистки',
      description:
        'Установив последнюю дату для артиста, её нельзя будет изменить. После установленной даты артист завершит контракт в вашем клубе.'
    },
    artistArrival: {
      title: 'Подтвердить присутствие?',
      description: 'Вы подтверждаете присутствие артиста в вашем клубе',
      information:
        'Работа начнётся с момента, когда вы подтвердите присутствие артиста на рабочем месте.'
    },
    workCancel: {
      title: 'Подтвердите отмену договора?',
      description: 'Вы подтверждаете отмену договора'
    },
    wantEndDate: {
      title: 'Артист хочет получить последнюю дату работы.'
    },
    newEndDate: {
      title: 'Последний день работы'
    }
  },
  artistWorkInteraction: {
    manageCurentContract: {
      pendingLastWorkDateRequest:
        ' Ваш запрос на завершение контракта находится на рассмотрении.',
      workStartOnArtistArrivalConfirm:
        ' Работа начнётся с момента, когда клуб подтвердит ваше присутствие на рабочем месте.',
      weCanRequestLastWorkDate:
        'Запросите дату завершения контракта у клуба.',
      clubSetLastWorkDate:
        'Клуб установил вашу последнюю дату работы в этом клубе.'
    }
  },
  changeProfile: {
    title: 'Мои клубы'
  },
  confirmOnboardingCompletion: {
    title: 'Резюме опубликовано',
    description: 'Теперь клубы смогут вас приглашать на работу'
  },
  videoUploading: {
    title: 'Загрузка Видео',
    description: 'Дождитесь загрузки видео'
  },
  addWorkItem: {
    title: 'Место работы',
    vacancyQuestion: 'На какой вакансии вы работали?',
    validationMessage: 'Вы уже установили, что работаете в настоящем времени.'
  },
  selectMainPhoto: {
    title: 'Главное фото',
    description: 'Укажите фото обложки для поиска'
  },
  deleteWorkExperience: {
    title: 'Удалить?',
    description: 'Вы уверены, что хотите удалить этот опыт работы?'
  }
};
